module.exports = __webpack_public_path__ + "static/whatwedo-a4fd556e2570a3e5c98cbfbf8d85389a.jpg";